(function(){

  var videos      = $('iframe[src*="//player.vimeo.com"], iframe[src*="//www.youtube.com"]');
  var videoParent  = $('.js-fluid-video');


  // For each video...
  $(videos).each(function() {
    // Save its height and width to a data property called "aspect-ratio".
    $(this).data('aspect-ratio', this.height / this.width).
    // Remove its hard-coded height and width values.
    removeAttr('height').removeAttr('width');
  });


  // When the window resizes...
  $(window).on('resize', function() {
    // Obtain the current width of a nearby fluid parent and save it to
    // newWidth. We need this, later, to tell the video how wide to be.
    var newWidth = $(videoParent).width();

    // For each video...
    $(videos).each(function() {
      // Assign its object to el.
      var el = $(this);
      // Set its width to equal newWidth, and its height to a value proportionate
      // to it's original height, maintaining its default aspect ratio.
      $(el).width(newWidth).height(newWidth * $(el).data('aspect-ratio'));
    });
  }).resize(); // Fire a resize immediately to kick all of this into motion.

})();
